import styled from 'styled-components';

export const StyledContainer = styled.section<{ $isTaskBreakdownSupported: boolean; $isHidden: boolean }>`
  display: flex;
  flex-direction: column;
  ${({ $isTaskBreakdownSupported }) => $isTaskBreakdownSupported && 'margin-top: 4.6rem'};
  ${({ $isTaskBreakdownSupported, theme }) =>
    !$isTaskBreakdownSupported &&
    `
      padding: 0 3rem 3rem;
      @media screen and (max-width: ${theme.sizes.lg}) {
        padding: 0 1.8rem 3rem 1.8rem;
      }
    `};

  ${({ $isHidden }) =>
    $isHidden &&
    `
      display: none;
   `}
`;

export const StyledTitleContainer = styled.div`
  gap: 1.6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
`;

export const StyledTextContainer = styled.div<{ isTaskComplete: boolean }>`
  display: inline;
  font-size: 1.8rem;
  color: ${({ theme, isTaskComplete }) => (isTaskComplete ? theme.colors.success.main : theme.colors.error.main)};
`;

export const StyledLineContainer = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 0.3rem;
  width: 100%;
`;

export const StyledLine = styled.span`
  width: 100%;
  height: 0.1rem;
  background: ${({ theme }) => theme.colors.border.light};
`;
